import { NQError, NQErrorCode } from '@visonum/network-quality-sdk';
import * as R from "ramda";
import { BuildVariant, IsProdType, ProcessEnv } from './config-types';

export const NODE_ENV: ProcessEnv = (process.env.NEXT_PUBLIC_NODE_ENV ?? "production") as ProcessEnv;

export const VARIANT: BuildVariant = (process.env.NEXT_PUBLIC_VARIANT ?? "WEB") as BuildVariant;

export const IS_PROD: IsProdType = (process.env.NEXT_PUBLIC_ISPROD ?? "false") as IsProdType;

const baseUrlOpt = process.env.NEXT_PUBLIC_API_URL;
if (R.isNil(baseUrlOpt)) {
    throw new NQError(NQErrorCode.Client, "NEXT_PUBLIC_API_URL cannot be undefined.");
}
export const baseUrl: string = baseUrlOpt;

const apiKeyOpt = process.env.NEXT_PUBLIC_API_KEY;
if (R.isNil(apiKeyOpt)) {
    throw new NQError(NQErrorCode.Client, "NEXT_PUBLIC_API_KEY cannot be undefined.");
}
export const API_KEY = apiKeyOpt;

export const appId = process.env.NEXT_PUBLIC_APP_ID;
